import { useCallback } from 'react';
import { useWfAlertHistoryStore } from '../stores/WfAlertHistoryStore';
import useWfAlertHistoryRepo from '../repository/WFAlertHistoryRepo';
import { mapDetailsResults, mapSearchResults } from '../models/WfAlertHistory';
import { useWfFilterStore } from '../stores/WfFilterStore';

function useWfAlertHistoryService() {
  const { historySearchParams, setHistory, history, selectedHistory } = useWfAlertHistoryStore();
  const { filterParameters } = useWfFilterStore();
  const { getAlertHistorySearchRequest, getAlertHistoryDetailsRequest } = useWfAlertHistoryRepo();

  const fetchHistory = useCallback(async () => {
    const _historySearchParams = historySearchParams;
    if (
      !_historySearchParams.customerNumber ||
      !_historySearchParams.disasterId ||
      !_historySearchParams.branchCode
    ) {
      setHistory(null);
      return;
    }

    const data = await getAlertHistorySearchRequest({
      customerNumber: _historySearchParams.customerNumber,
      disasterId: _historySearchParams.disasterId,
      branchCode: _historySearchParams.branchCode,
    });
    setHistory(mapSearchResults(data));
  }, [getAlertHistorySearchRequest, historySearchParams, setHistory]);

  const fetchHistoryDetails = useCallback(
    async (id: number) => {
      const record =
        (selectedHistory?.alertHistoryId === id && selectedHistory) ||
        history?.alertHistoryRecords?.find((item) => item.alertHistoryId === id);

      const disasterId = record?.disasterId ?? filterParameters.disasterId?.trim();
      const buildingCode = record?.buildingCode;
      const customerNumber = record?.customerNumber;
      const branchCode = record?.branchCode;
      const propertyName1 = record?.propertyName1;
      const propertyName2 = record?.propertyName2;
      const propertyName3 = record?.propertyName3;
      const propertyName4 = record?.propertyName4;

      if (!disasterId || !buildingCode || !customerNumber || !branchCode) return [];

      const details = await getAlertHistoryDetailsRequest({
        disasterId,
        buildingCode,
        customerNumber,
        branchCode,
        propertyName1,
        propertyName2,
        propertyName3,
        propertyName4,
      });
      return mapDetailsResults(details);
    },
    [
      filterParameters.disasterId,
      getAlertHistoryDetailsRequest,
      history?.alertHistoryRecords,
      selectedHistory,
    ]
  );

  return { fetchHistory, fetchHistoryDetails };
}

export default useWfAlertHistoryService;
